
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/pif",
      function () {
        return require("private-next-pages/shop/pif.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/pif"])
      });
    }
  